import { CardOnFileActionsJustifi } from '../../../components/card-on-file/actions/actions-justifi';
import { CardOnFileActionsStripe } from '../../../components/card-on-file/actions/actions-stripe';
import { ContextToProps } from '../context-to-props';

export type CardOnFileDefaultActionsProps = {
  shouldUsePadding?: boolean;
};

export const CardOnFileDefaultActions = (props: CardOnFileDefaultActionsProps) => {
  return (
    <ContextToProps.Actions
      {...props}
      stripeComponent={CardOnFileActionsStripe}
      justifiComponent={CardOnFileActionsJustifi}
    />
  );
};
